(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-oneof-detail-765"] && !Shopify.designMode) return;
  try {
    
function initOneofProduct() {
  document.querySelectorAll('[data-oneof-gallery]').forEach(function (gallery) {
    if (gallery.dataset.ready) return;
    gallery.dataset.ready = '1';
    var slides = [...gallery.querySelectorAll('[data-oneof-slide]')];
    var thumbs = [...gallery.querySelectorAll('[data-oneof-thumb]')];
    var zooms = [...gallery.querySelectorAll('[data-oneof-zoom]')];
    var lightbox = gallery.closest('.lp-oneof-product').querySelector('[data-oneof-lightbox]');
    var lightboxImage = lightbox.querySelector('[data-oneof-lightbox-image]');
    var lightboxCount = lightbox.querySelector('[data-oneof-lightbox-count]');
    var index = 0;
    if (!slides.length) return;

    function show(n) {
      index = (n + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      thumbs.forEach(function (thumb, i) {
        thumb.parentElement.classList.toggle('is-active', i === index);
        thumb.setAttribute('aria-pressed', i === index ? 'true' : 'false');
      });
      thumbs[index]?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      if (lightbox.open) {
        var preview = zooms[index].querySelector('img');
        lightboxImage.src = zooms[index].dataset.oneofFull || preview.src;
        lightboxImage.alt = preview.alt;
        lightboxCount.textContent = (index + 1) + ' / ' + slides.length;
      }
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { show(i); });
    });
    gallery.querySelector('[data-oneof-prev]')?.addEventListener('click', function () { show(index - 1); });
    gallery.querySelector('[data-oneof-next]')?.addEventListener('click', function () { show(index + 1); });
    zooms.forEach(function (button, i) {
      button.addEventListener('click', function () {
        index = i;
        lightbox.showModal();
        show(i);
      });
    });
    lightbox.querySelector('[data-oneof-lightbox-prev]').addEventListener('click', function () { show(index - 1); });
    lightbox.querySelector('[data-oneof-lightbox-next]').addEventListener('click', function () { show(index + 1); });
    lightbox.querySelector('[data-oneof-close]').addEventListener('click', function () { lightbox.close(); });
    lightbox.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1); }
    });
    var touchStartX = 0;
    var touchStartY = 0;
    lightboxImage.addEventListener('touchstart', function (event) {
      touchStartX = event.changedTouches[0].screenX;
      touchStartY = event.changedTouches[0].screenY;
    }, { passive: true });
    lightboxImage.addEventListener('touchend', function (event) {
      var dx = event.changedTouches[0].screenX - touchStartX;
      var dy = event.changedTouches[0].screenY - touchStartY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.2) show(index + (dx < 0 ? 1 : -1));
    }, { passive: true });
    show(0);
  });

  document.querySelectorAll('[data-oneof-tabs]').forEach(function (root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var tabs = [...root.querySelectorAll('[data-oneof-tab]')];
    var panels = [...root.querySelectorAll('[data-oneof-panel]')];
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (item, j) {
          item.classList.toggle('is-active', i === j);
          item.setAttribute('aria-selected', i === j ? 'true' : 'false');
          panels[j].classList.toggle('is-active', i === j);
          panels[j].hidden = i !== j;
        });
      });
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initOneofProduct);
else initOneofProduct();
document.addEventListener('shopify:section:load', initOneofProduct);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-oneof-detail-caterham"] && !Shopify.designMode) return;
  try {
    
function initOneofProduct() {
  document.querySelectorAll('[data-oneof-gallery]').forEach(function (gallery) {
    if (gallery.dataset.ready) return;
    gallery.dataset.ready = '1';
    var slides = [...gallery.querySelectorAll('[data-oneof-slide]')];
    var thumbs = [...gallery.querySelectorAll('[data-oneof-thumb]')];
    var zooms = [...gallery.querySelectorAll('[data-oneof-zoom]')];
    var lightbox = gallery.closest('.lp-oneof-product').querySelector('[data-oneof-lightbox]');
    var lightboxImage = lightbox.querySelector('[data-oneof-lightbox-image]');
    var lightboxCount = lightbox.querySelector('[data-oneof-lightbox-count]');
    var index = 0;
    if (!slides.length) return;

    function show(n) {
      index = (n + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      thumbs.forEach(function (thumb, i) {
        thumb.parentElement.classList.toggle('is-active', i === index);
        thumb.setAttribute('aria-pressed', i === index ? 'true' : 'false');
      });
      thumbs[index]?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      if (lightbox.open) {
        var preview = zooms[index].querySelector('img');
        lightboxImage.src = zooms[index].dataset.oneofFull || preview.src;
        lightboxImage.alt = preview.alt;
        lightboxCount.textContent = (index + 1) + ' / ' + slides.length;
      }
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { show(i); });
    });
    gallery.querySelector('[data-oneof-prev]')?.addEventListener('click', function () { show(index - 1); });
    gallery.querySelector('[data-oneof-next]')?.addEventListener('click', function () { show(index + 1); });
    zooms.forEach(function (button, i) {
      button.addEventListener('click', function () {
        index = i;
        lightbox.showModal();
        show(i);
      });
    });
    lightbox.querySelector('[data-oneof-lightbox-prev]').addEventListener('click', function () { show(index - 1); });
    lightbox.querySelector('[data-oneof-lightbox-next]').addEventListener('click', function () { show(index + 1); });
    lightbox.querySelector('[data-oneof-close]').addEventListener('click', function () { lightbox.close(); });
    lightbox.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1); }
    });
    var touchStartX = 0;
    var touchStartY = 0;
    lightboxImage.addEventListener('touchstart', function (event) {
      touchStartX = event.changedTouches[0].screenX;
      touchStartY = event.changedTouches[0].screenY;
    }, { passive: true });
    lightboxImage.addEventListener('touchend', function (event) {
      var dx = event.changedTouches[0].screenX - touchStartX;
      var dy = event.changedTouches[0].screenY - touchStartY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.2) show(index + (dx < 0 ? 1 : -1));
    }, { passive: true });
    show(0);
  });

  document.querySelectorAll('[data-oneof-tabs]').forEach(function (root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var tabs = [...root.querySelectorAll('[data-oneof-tab]')];
    var panels = [...root.querySelectorAll('[data-oneof-panel]')];
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (item, j) {
          item.classList.toggle('is-active', i === j);
          item.setAttribute('aria-selected', i === j ? 'true' : 'false');
          panels[j].classList.toggle('is-active', i === j);
          panels[j].hidden = i !== j;
        });
      });
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initOneofProduct);
else initOneofProduct();
document.addEventListener('shopify:section:load', initOneofProduct);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-oneof-detail"] && !Shopify.designMode) return;
  try {
    
function initLpsrOneofProduct() {
  document.querySelectorAll('[data-oneof-gallery]').forEach(function (gallery) {
    if (gallery.dataset.ready) return;
    var slides = Array.from(gallery.querySelectorAll('[data-oneof-slide]'));
    var thumbs = Array.from(gallery.querySelectorAll('[data-oneof-thumb]'));
    var zooms = Array.from(gallery.querySelectorAll('[data-oneof-zoom]'));
    var lightbox = gallery.closest('.lp-oneof-product').querySelector('[data-oneof-lightbox]');
    if (!slides.length || !lightbox) return;
    gallery.dataset.ready = '1';
    var lightboxImage = lightbox.querySelector('[data-oneof-lightbox-image]');
    var lightboxCount = lightbox.querySelector('[data-oneof-lightbox-count]');
    var index = 0;

    function show(n) {
      index = (n + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      thumbs.forEach(function (thumb, i) {
        thumb.parentElement.classList.toggle('is-active', i === index);
        thumb.setAttribute('aria-pressed', i === index ? 'true' : 'false');
      });
      thumbs[index]?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      if (lightbox.open) {
        var image = zooms[index].querySelector('img');
        lightboxImage.src = image.src;
        lightboxImage.alt = image.alt;
        lightboxCount.textContent = (index + 1) + ' / ' + slides.length;
      }
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { show(i); });
    });
    gallery.querySelector('[data-oneof-prev]')?.addEventListener('click', function () { show(index - 1); });
    gallery.querySelector('[data-oneof-next]')?.addEventListener('click', function () { show(index + 1); });
    zooms.forEach(function (button, i) {
      button.addEventListener('click', function () {
        lightbox.showModal();
        show(i);
      });
    });
    lightbox.querySelector('[data-oneof-lightbox-prev]').addEventListener('click', function () { show(index - 1); });
    lightbox.querySelector('[data-oneof-lightbox-next]').addEventListener('click', function () { show(index + 1); });
    lightbox.querySelector('[data-oneof-close]').addEventListener('click', function () { lightbox.close(); });
    lightbox.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1); }
    });
    var touchStartX = 0;
    var touchStartY = 0;
    lightboxImage.addEventListener('touchstart', function (event) {
      touchStartX = event.changedTouches[0].screenX;
      touchStartY = event.changedTouches[0].screenY;
    }, { passive: true });
    lightboxImage.addEventListener('touchend', function (event) {
      var dx = event.changedTouches[0].screenX - touchStartX;
      var dy = event.changedTouches[0].screenY - touchStartY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.2) {
        show(index + (dx < 0 ? 1 : -1));
      }
    }, { passive: true });
    show(0);
  });

  document.querySelectorAll('[data-oneof-tabs]').forEach(function (root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var tabs = Array.from(root.querySelectorAll('[data-oneof-tab]'));
    var panels = Array.from(root.querySelectorAll('[data-oneof-panel]'));
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (item, j) {
          item.classList.toggle('is-active', i === j);
          item.setAttribute('aria-selected', i === j ? 'true' : 'false');
          panels[j].classList.toggle('is-active', i === j);
          panels[j].hidden = i !== j;
        });
      });
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLpsrOneofProduct);
else initLpsrOneofProduct();
document.addEventListener('shopify:section:load', initLpsrOneofProduct);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-oneof-video-hero"] && !Shopify.designMode) return;
  try {
    
function initOneofHeroes(){document.querySelectorAll('[data-oneof-hero]').forEach(function(root){if(root.dataset.oneofReady)return;root.dataset.oneofReady='true';var slides=Array.from(root.querySelectorAll('[data-oneof-slide]'));var dots=Array.from(root.querySelectorAll('[data-oneof-dot]'));var pause=root.querySelector('[data-oneof-pause]');var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;var index=0;var paused=reduced;function show(next){if(!slides.length)return;index=(next+slides.length)%slides.length;slides.forEach(function(slide,i){var active=i===index;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',active?'false':'true');var video=slide.querySelector('video');if(video){video.pause();if(active){try{video.currentTime=0}catch(e){}if(!paused)video.play().catch(function(){})}}});dots.forEach(function(dot,i){dot.classList.toggle('is-active',i===index);dot.setAttribute('aria-pressed',i===index?'true':'false')});if(pause){pause.textContent=paused?'▶':'Ⅱ';pause.setAttribute('aria-label',paused?pause.dataset.playLabel:pause.dataset.pauseLabel)}}slides.forEach(function(slide){var video=slide.querySelector('video');if(video)video.addEventListener('ended',function(){if(!paused)show(index+1)})});dots.forEach(function(dot,i){dot.addEventListener('click',function(){show(i)})});if(pause)pause.addEventListener('click',function(){paused=!paused;if(paused){var video=slides[index].querySelector('video');if(video)video.pause();pause.textContent='▶';pause.setAttribute('aria-label',pause.dataset.playLabel)}else{var video=slides[index].querySelector('video');if(video)video.play().catch(function(){});pause.textContent='Ⅱ';pause.setAttribute('aria-label',pause.dataset.pauseLabel)}});var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){var video=slides[index]&&slides[index].querySelector('video');if(!video)return;if(entry.isIntersecting){if(!paused)video.play().catch(function(){})}else video.pause()})},{threshold:.25});observer.observe(root);show(0)})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initOneofHeroes);else initOneofHeroes();document.addEventListener('shopify:section:load',initOneofHeroes);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-support-page"] && !Shopify.designMode) return;
  try {
    
  function initLpSupportVideo() {
    document.querySelectorAll('.lp-support__hero-media').forEach((media) => {
      if (media.dataset.videoReady) return;
      media.dataset.videoReady = 'true';
      const video = media.querySelector('video');
      const toggle = media.querySelector('.lp-support__video-toggle');
      if (!video || !toggle) return;
      const sync = () => {
        const paused = video.paused;
        toggle.textContent = paused ? toggle.dataset.playText : toggle.dataset.pauseText;
        toggle.setAttribute('aria-label', paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
      };
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      toggle.addEventListener('click', () => {
        if (video.paused) video.play().catch(() => {});
        else video.pause();
      });
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) video.pause();
      sync();
    });
  }
  initLpSupportVideo();
  document.addEventListener('shopify:section:load', initLpSupportVideo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-used-wear-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-lp-wear-prev], [data-lp-wear-next]');
    if (!button) return;
    var section = button.closest('.lp-wear');
    var viewport = section && section.querySelector('[data-lp-wear-viewport]');
    if (!viewport) return;
    var slide = viewport.querySelector('.lp-wear__slide');
    if (!slide) return;
    var distance = slide.getBoundingClientRect().width + 16;
    viewport.scrollBy({ left: button.hasAttribute('data-lp-wear-prev') ? -distance : distance, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
